import { useInterstateTheme } from './useInterstateTheme';
import { getTokenFromTheme } from './getTokenFromTheme';
/**
 * Hook that provides a function for getting a token from the token library
 */
export const useInterstateToken = () => {
  const theme = useInterstateTheme();
  return tokenName => {
    const token = getTokenFromTheme(theme, tokenName);
    if (process.env.NODE_ENV !== 'production' && !token) {
      // eslint-disable-next-line no-console
      console.warn(`Token not found in theme: ${tokenName}`);
    }
    return token;
  };
};